import React, { useEffect, useState, useRef } from 'react';
import DualRings from './DualRings';
import './ExerciseTimer.css';
import { FaPlay, FaPause, FaForward, FaBan, FaPlusCircle, FaRegCircle } from 'react-icons/fa';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { FaExpand, FaCompress } from 'react-icons/fa';
import api from './api';
import { useDialog } from './useDialog';

function formatTime(timeInSeconds) {
  var minutes = Math.floor(timeInSeconds / 60);
  var seconds = timeInSeconds % 60;
  return ' ' + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
}



function ExerciseTimerWithList(props) {
  var initExercises = props.exercises.slice();
  var showButtons = props.showButtons;
  var onParsedData = props.onParsedData;
  //console.log("show Buttons = ", showButtons);
  //console.log("patientCard = ", props.patientCard);
  // Extended state
 var [exercises, setExercises] = useState(initExercises.map((ex, i) => {
  const duration = ex.duration ?? 1;     // default to 1 if undefined or null
  const repetition = ex.repetition ?? 1; // default to 1 if undefined or null
  return {
    ...ex,
    id: ex.name + '-' + i,
    duration,
    repetition,
    status: 'notStarted',
    pendingreps: repetition,
    executedate: null,
    caloriesBurned: 0,
    completedReps: 0,
    wasRestarted: false,
  };
}));
  
  


  const SNAPSHOT_KEY = `workoutSnapshot-${showButtons?._id}`;

  var [viewMode, setViewMode] = useState('reorder'); // reorder/timer
  var [currentExerciseIndex, setCurrentExerciseIndex] = useState(0);
  var [totalWorkoutTime, setTotalWorkoutTime] = useState(0);  
  var [remainingTime, setRemainingTime] = useState(exercises[0]?.duration || 0);
  var [startTime, setStartTime] = useState(null);
  var [elapsedTime, setElapsedTime] = useState(0);
  var [isPaused, setIsPaused] = useState(true);
  var [isStopped, setIsStopped] = useState(false);
  var [status, setStatus] = useState("");
  var [repetitionCount, setRepetitionCount] = useState(0);
  var [segments, setSegments] = useState([]);
  var [showRestartSkipped, setShowRestartSkipped] = useState(false);
  var [restartedSkipped, setRestartedSkipped] = useState(false);
  var [showWorkoutCompleteModal, setShowWorkoutCompleteModal] = useState(false);
  var [showExers, setShowExers] = useState(true);
  
var soundLoopRef = useRef(null); // already exists

  var intervalRef = useRef(null);
  var isWorkoutComplete = useRef(false);
  var audioRef = useRef(null);
  var exercisesRef = useRef(exercises); // always-current copy for use inside setInterval
  var originalTotalWorkoutTimeRef = useRef(null); // set once on first load, never changes
  const { dialogNode, showConfirm, showPrompt } = useDialog();

var COLORS = [
  '#2ecc71', '#f39c12', '#1e90ff', '#ff7f50', '#8e44ad',
  '#16a085', '#c0392b', '#2980b9', '#27ae60', '#d35400',
  '#f1c40f', '#7f8c8d', '#e74c3c', '#bdc3c7', '#2c3e50',
  '#4db8ff', '#ff6b6b', '#ffa94d', '#6bcf63', '#9b59b6',
  '#ffcc00', '#3498db', '#e67e22', '#1abc9c', '#e84393',
  '#a29bfe', '#fd79a8', '#55efc4', '#ffeaa7', '#fab1a0',
  '#81ecec', '#74b9ff', '#a3cb38', '#e17055', '#6c5ce7',
  '#00cec9', '#d63031', '#e84393', '#fdcb6e', '#636e72'
];

useEffect(() => {
  if (showButtons?.status === 'inprogress') {
    const saved = sessionStorage.getItem(SNAPSHOT_KEY);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setExercises(parsed.exercises || []);
        setCurrentExerciseIndex(parsed.currentExerciseIndex || 0);
        setElapsedTime(parsed.elapsedTime || 0);
        setRemainingTime(parsed.remainingTime || 0);
        setRepetitionCount(parsed.repetitionCount || 0);
        setStartTime(new Date(parsed.startTime) || new Date());
        setSegments(parsed.segments || []);
        setViewMode('timer');
        setIsPaused(true); // Pause on reload, wait for user to click Play again
        setIsStopped(false);
        isWorkoutComplete.current = parsed.isWorkoutComplete || false;
        console.log("Restored from snapshot:", parsed);
      } catch (e) {
        console.error("Failed to parse snapshot:", e);
      }
    }
  }
}, []);


useEffect(() => {
  const timeout = setTimeout(() => {
    saveSnapshot(); // ✅ will have latest state due to closure
  }, 500); // debounce delay in ms

  return () => clearTimeout(timeout); // clear on re-render

  }, [
      exercises,
      currentExerciseIndex,
      //elapsedTime,
      //remainingTime,
      repetitionCount,
      startTime,
      segments,
    ]
);

/*
useEffect(() => {
  function handleUserInteraction() {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    if (soundLoopRef.current) {
      clearTimeout(soundLoopRef.current);
      soundLoopRef.current = null;
    }
    // Remove listener after first interaction
    document.removeEventListener('click', handleUserInteraction);
    document.removeEventListener('touchstart', handleUserInteraction);
  }

  document.addEventListener('click', handleUserInteraction);
  document.addEventListener('touchstart', handleUserInteraction);

  return () => {
    document.removeEventListener('click', handleUserInteraction);
    document.removeEventListener('touchstart', handleUserInteraction);
  };
}, []);  // empty array = global listener
*/

useEffect(() => {
  if (audioRef.current) {
    audioRef.current.load(); // ensures it's initialized
  }
}, []);

// Keep exercisesRef in sync so the setInterval closure always has the latest list
useEffect(() => {
  exercisesRef.current = exercises;
}, [exercises]);

function unlockAudio() {
  const audio = audioRef.current;
  if (!audio) return;

  // Try to unlock sound on first tap
  audio.play()
    .then(() => {
      audio.pause();
      audio.currentTime = 0;
      
      console.log("🔓 Audio unlocked!");
    })
    .catch(err => {
      console.warn("⚠️ Audio play blocked:", err);
      alert("Please tap to enable sound.");
    });
}

function playSound() {
  if (!audioRef.current) 
  {
    alert('audioRef is null. Cant play sound');
    return;
  };

  const audio = audioRef.current;
  const duration = 40000; // 30 seconds
  const interval = 5000;  // play every 2 seconds
  const endTime = Date.now() + duration;

  function loopSound() {
    if (Date.now() >= endTime) return;

    audio.currentTime = 0;
    audio.volume = 1;
    audio.muted = false;
    audio.play().catch(() => {});

    soundLoopRef.current = setTimeout(loopSound, interval);
  }

  loopSound(); // Start looping
}

function playFinalSoundWithAlert(finalExercises) {
  if (!audioRef.current) return;

  const audio = audioRef.current;
  audio.currentTime = 0;
  audio.volume = 1;
  audio.loop = true;
  audio.play().catch(() => {});

  // Show custom alert/modal
  setShowWorkoutCompleteModal(true);
  if (props.onWorkoutComplete) {
    // Use the explicitly-built finalExercises so the last exercise is marked Completed
    props.onWorkoutComplete("Completed", finalExercises || exercises);
    setStatus("Completed");
  }
  setShowExers(false);
}

async function skipAllRemaining(showMsg = 1) {
  stopAudio();

  if (showMsg)
  {
    var ret = await showConfirm("Are you sure you want to Skip all the remaining exercises and finish the session ?");
    if (!ret) return;
  }
 
// ✅ Now safely handle side effects:
setSegments([]);
setStartTime(new Date());
setIsPaused(true);
setIsStopped(true);
setCurrentExerciseIndex(0);
setRepetitionCount(0);
setRemainingTime(0);
isWorkoutComplete.current = true;
setShowRestartSkipped(true);
//sessionStorage.removeItem(SNAPSHOT_KEY); // ✅ moved out of setter

  // Show custom alert/modal
  setShowWorkoutCompleteModal(true);
  if (props.onWorkoutComplete) {
    props.onWorkoutComplete('Skipped', exercises); // ⬅️ Call parent callback
    setStatus("Skipped");
  }
  setShowExers(false);
}

const stopAudio = () => {
  
   if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
                audioRef.current.loop = false;
              }
              if (soundLoopRef.current) {
                clearTimeout(soundLoopRef.current); // ✅ stop further looping
                soundLoopRef.current = null;
              }
};

const updateApptToInProgress = () => {
  
  if (showButtons)
  {
    if (showButtons.status != 'scheduled')
      return;
    // very 1st in-progress of appt
    const payload = { status: "inprogress", startTime: new Date()  };
    /*
    const regex = /^workoutSnapshot/;

    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (regex.test(key)) {
        sessionStorage.removeItem(key);
      }
    } */

   updateAppt(payload, 1);
  }
};

  function updateAppt(payload, firstInst = 0)
  {
     api.post(
        `${process.env.REACT_APP_URL}/appointments/update/${showButtons._id}/`, payload )
      .then(() => {
        console.log("Session started");
        if(props.onWorkoutStart && firstInst) {
          props.onWorkoutStart("notStarted", exercises);
          setStatus("notStarted");
        }
      })
      .catch((e) => {
        console.error("Error updating session:", e);
        
      });
  }

 /*
  var totalWorkoutTime = exercises.reduce(function(total, exercise) {
    return total + (exercise?.duration ?? 1) * (exercise?.repetition ?? 1);
  }, 0);
*/
const firstLoadRef = useRef(true);
const prevExercisesRef = useRef([]);

useEffect(() => {
  const propsChanged = JSON.stringify(props.exercises) !== JSON.stringify(prevExercisesRef.current);

  // ✅ Bug 4 fix: guard restored — only sync when props genuinely change, not on every parent render.
  // Without this guard every parent re-render would call setExercises() and wipe status/pendingreps.
  if (propsChanged) {
    const mapped = props.exercises.map((ex, i) => ({
      ...ex,
      id: ex.name + '-' + i,
      wasRestarted: false
    }));
    console.log("Props exers changed -- should happen only once at load");
    setExercises(mapped);
    prevExercisesRef.current = props.exercises;

    const totalTime = mapped.reduce(
      (total, exercise) => total + (exercise.duration ?? 1) * (exercise.repetition ?? 1),
      0
    ) || 50;
    setTotalWorkoutTime(totalTime);
    // Store original planned time once (never overwritten)
    if (originalTotalWorkoutTimeRef.current === null) {
      originalTotalWorkoutTimeRef.current = totalTime;
    }
  }
}, [props.exercises]);

// Recompute totalWorkoutTime whenever exercises are modified at runtime (add/remove/duration change)
useEffect(() => {
  if (originalTotalWorkoutTimeRef.current === null) return; // not yet initialized
  const current = exercises.reduce(
    (total, ex) => total + (ex.duration ?? 1) * (ex.repetition ?? 1),
    0
  ) || 50;
  setTotalWorkoutTime(current);
}, [exercises]);

  useEffect(function() {
    if (!startTime) {
      setStartTime(new Date());
    }
    if (viewMode !== 'timer' || isWorkoutComplete.current) return;

    if (!isPaused && !isStopped) {
      intervalRef.current = setInterval(function() {

        setElapsedTime(prev => prev + 1);

        // ✅ Use exercisesRef.current so the closure always reads the latest exercises
        var currentExercise = exercisesRef.current[currentExerciseIndex];
        if (currentExercise &&
            currentExercise.status !== 'Skipped' &&
            currentExercise.status !== 'Completed' &&
            currentExercise.status !== 'OnGoing')
        {
            const updated = [...exercisesRef.current];
            updated[currentExerciseIndex] = {
              ...currentExercise,
              status: 'OnGoing',
            };
            setExercises(updated);
            if (onParsedData)
              onParsedData(currentExercise, currentExerciseIndex);
        }

        setRemainingTime(function(prevRemainingTime) {
          if (prevRemainingTime > 0) return prevRemainingTime - 1;

          playSound();

          var segmentProgress = ((currentExercise.duration) / (totalWorkoutTime)) * 100;
          var color = COLORS[currentExerciseIndex % COLORS.length];
          setSegments(prev => prev.concat([{ progress: segmentProgress, color }]));

          var exr = { ...currentExercise };
          exr.executedate = new Date().toDateString();

          if (repetitionCount < exr.repetition - 1) {
            setRepetitionCount(prev => prev + 1);
            // ✅ Bug 5 fix: only return the value — don't also call setRemainingTime directly
            setIsPaused(true);
            exr.pendingreps = exr.pendingreps - 1;
            setExercises(exs => { var a = [...exs]; a[currentExerciseIndex] = exr; return a; });
            if (onParsedData)
              onParsedData(exr, currentExerciseIndex);
            return exr.duration;
          } else {
            // Completed one exercise
            exr.pendingreps = 0;
            exr.status = 'Completed';
            exr.startTime = startTime;
            exr.endTime = new Date();
            setExercises(exs => { var a = [...exs]; a[currentExerciseIndex] = exr; return a; });
            if (onParsedData) onParsedData(exr, currentExerciseIndex);

            // ✅ Use exercisesRef.current for up-to-date list length and next exercise duration
            const exList = exercisesRef.current;
            if (currentExerciseIndex < exList.length - 1) {
              setCurrentExerciseIndex(idx => idx + 1);
              setRepetitionCount(0);
              // ✅ Bug 5 fix: only return the value — don't also call setRemainingTime directly
              setIsPaused(true);
              return exList[currentExerciseIndex + 1].duration;
            } else {
              clearInterval(intervalRef.current);
              isWorkoutComplete.current = true;
              setIsStopped(true);
              setShowRestartSkipped(true);
              // ✅ Bug 2 fix: build the final list with last exercise marked Completed
              const finalExercises = [...exList];
              finalExercises[currentExerciseIndex] = exr;
              playFinalSoundWithAlert(finalExercises);
              return 0;
            }
          }
        });

      }, 1000);
    }
    return function() {
      clearInterval(intervalRef.current);
    };
  // ✅ Bug 3 fix: removed `exercises` from deps — interval reads exercises via exercisesRef.current
  }, [viewMode, currentExerciseIndex, isPaused, isStopped, repetitionCount, restartedSkipped]);

  useEffect(() => {
  if (props.onRemainingTimeChange) {
    props.onRemainingTimeChange(formattedTime);
  }
}, [remainingTime]);
/*
function handleSkip() {
    var rt = remainingTime;
    const currentEx = exercises[currentExerciseIndex];

    if (repetitionCount < currentEx.repetition - 1) {
      // still some reps left, skip all remaining reps of this exercise
      rt = (currentEx.repetition - repetitionCount - 1) * currentEx.duration;
    }

    //if (repetitionCount < exercises[currentExerciseIndex].repetition) {
    //  rt = (exercises[currentExerciseIndex].repetition - repetitionCount) *
    //    exercises[currentExerciseIndex].duration;
    //}

    var segmentProgress = ((elapsedTime + rt) / (totalWorkoutTime)) * 100;
    var color = COLORS[currentExerciseIndex % COLORS.length];
    setSegments(prev => prev.concat([{ progress: segmentProgress, color }]));

    //var exr = { ...exercises[currentExerciseIndex] };
     var exr = { ...currentEx };
    exr.status = 'Skipped';
    exr.pendingreps = 0;
    exr.startTime = startTime;
    exr.endTime = new Date();
      
    // Update exercises state
    setExercises(exs => {
      const newExs = [...exs];
      newExs[currentExerciseIndex] = exr;

      // Advance to next exercise safely using updated array
      if (currentExerciseIndex < newExs.length - 1) {
        setCurrentExerciseIndex(currentExerciseIndex + 1);
        setRemainingTime(newExs[currentExerciseIndex + 1].duration);
        setRepetitionCount(0);  // important!
        setIsPaused(true);
      } else {
        setRemainingTime(0);
        setRepetitionCount(currentEx.repetition - 1);
        clearInterval(intervalRef.current);
        setIsStopped(true);
        alert('Skipped - Workout Complete!');
        skipAllRemaining(0);
      }

      return newExs;
    });
    if (onParsedData) onParsedData(exr, currentExerciseIndex);
    //setTimeout(() => saveSnapshot(), 1000);  // <-- ✅ after skipping
  }
*/

function handleSkip() {
  const currentEx = exercises[currentExerciseIndex];
  const isLastExercise = currentExerciseIndex === exercises.length - 1;

  // Calculate remaining time of this exercise's reps
  let remainingTimeForReps = 0;
  if (repetitionCount < currentEx.repetition) {
    remainingTimeForReps = (currentEx.repetition - repetitionCount) * currentEx.duration;
  }

  // Segment update
  const segmentProgress = ((elapsedTime + remainingTimeForReps) / (totalWorkoutTime)) * 100;
  const color = COLORS[currentExerciseIndex % COLORS.length];
  setSegments(prev => prev.concat([{ progress: segmentProgress, color }]));

  // Update current exercise to 'Skipped'
  const exr = {
    ...currentEx,
    status: 'Skipped',
    pendingreps: 0,
    startTime,
    endTime: new Date()
  };

  // Handle state update
  setExercises(prevExercises => {
    const updated = [...prevExercises];
    updated[currentExerciseIndex] = exr;
    return updated;
  });

  if (onParsedData) onParsedData(exr, currentExerciseIndex);

  if (!isLastExercise) {
    // Move to next exercise
    setCurrentExerciseIndex(currentExerciseIndex + 1);
    setRepetitionCount(0);
    setRemainingTime(exercises[currentExerciseIndex + 1].duration);
    setIsPaused(true);
  } else {
    // Handle end of workout
    setRemainingTime(0);
    setRepetitionCount(0); // <-- important
    clearInterval(intervalRef.current);
    isWorkoutComplete.current = true;  // <-- critical
    setIsStopped(true);
    setShowRestartSkipped(true);  // optional
    alert('Skipped - Workout Complete!');
    skipAllRemaining(0);
  }

  // Optional: save snapshot of skipped state
  // saveSnapshot();  
}

function restartSkipped() {

  // Reset state
  const payload = { status: "inprogress" };
  updateAppt(payload, 0); // put the appt status back to inprogress
  
  setExercises(prevExercises => {
    const Skipped = prevExercises.filter(ex => ex.status === 'Skipped');
    if (Skipped.length === 0) {
      alert('No Skipped exercises to restart.');
      return prevExercises;
    }

    const Completed = prevExercises.filter(ex => ex.status === 'Completed');

    const reset = Skipped.map(ex => ({
      ...ex,
      pendingreps: ex.repetition,
      executedate: null,
      status: 'notStarted',
      wasRestarted: true, // 🔶 Flag for visual highlight
    }));

    const completed = prevExercises.filter(ex => ex.status === 'Completed');
    const inProgress = prevExercises.filter(ex => ex.status !== 'Skipped' && ex.status !== 'Completed');

    const newList = [...reset, ...inProgress, ...completed];
    console.log("workoutcomeplete --> " , props.isWorkoutComplete);
    isWorkoutComplete.current = false;
    setSegments([]);
    setElapsedTime(0);
    setStartTime(new Date());
    setIsPaused(true);
    setIsStopped(false);
    setCurrentExerciseIndex(0);
    setRepetitionCount(0);
    setRemainingTime(reset[0].duration);
    
    setShowRestartSkipped(false);
    setShowExers(true);
    props.onWorkoutComplete("restarted", newList);
    setStatus("restarted");
    //setTimeout(() => saveSnapshot(), 100);  // <-- ✅ after resetting Skipped exercises
    return newList;
  });
}

  const currentExercise = exercises[currentExerciseIndex];
  //const progress = ((remainingTime / (currentExercise.duration)) * 100).toFixed(2);
  const progress = Math.min(
    Math.ceil((remainingTime / (currentExercise.duration)) * 100),
    100
  );

  const totalElapsedThis = elapsedTime -
    (currentExerciseIndex > 0
      ? exercises
          .slice(0, currentExerciseIndex)
          .reduce((acc, ex) => acc + ex.duration * ex.repetition, 0)
      : 0);
  const outerProgress = Math.min(
    (totalElapsedThis / (currentExercise.duration * currentExercise.repetition)) * 100,
    100
  ).toFixed(2);

  const formattedTime = remainingTime > 0 ? formatTime(remainingTime) : '00:00';
  //const completedExercises = exercises.filter(ex => ex.status === 'Completed');
  //const upcomingExercises = exercises.slice(currentExerciseIndex + 1);

  const completedExercises = exercises.filter(ex => ex.status === 'Completed');

const upcomingExercises = exercises.filter(
  (ex, idx) =>
    idx > currentExerciseIndex &&
    ex.status !== 'Completed' &&
    ex.status !== 'Skipped'
);

  function handleDragEnd(result) {
    if (!result.destination) return;
    const newItems = Array.from(exercises);
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);
    setExercises(newItems);

    // Reset timer & index to match new first exercise
  setCurrentExerciseIndex(0);
  setRemainingTime(newItems[0]?.duration || 0);
  setIsPaused(true);
  setIsStopped(false);
  }

  
// ✅ Bug 1 fix: only reset remainingTime when the exercise INDEX changes, NOT on every
// exercises array update. Previously, updating any exercise's status (e.g. → 'OnGoing')
// triggered this effect and reset the countdown to full duration every second (hang loop).
useEffect(() => {
  if (exercisesRef.current.length > 0 && currentExerciseIndex < exercisesRef.current.length) {
    setRemainingTime(exercisesRef.current[currentExerciseIndex].duration);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentExerciseIndex]);

function handleUpcomingReorder(result) {
   console.log("DRAG ENDED", result); // 🧪 Should print on every drag end
  if (!result.destination) return;

  // Split exercises into three parts:
  const completed = exercises.slice(0, currentExerciseIndex + 1); // includes current
  const upcoming = exercises.slice(currentExerciseIndex + 1);

  // Reorder only the upcoming list
  const reorderedUpcoming = Array.from(upcoming);
  const [movedItem] = reorderedUpcoming.splice(result.source.index, 1);
  reorderedUpcoming.splice(result.destination.index, 0, movedItem);

  // Merge and update
  const updatedExercises = [...completed, ...reorderedUpcoming];
  setExercises(updatedExercises);

  //setTimeout(() => saveSnapshot(), 1000); // optional: save state
}


function saveSnapshot() {
  const snapshot = {
    exercises,
    currentExerciseIndex,
    elapsedTime,
    remainingTime,
    repetitionCount,
    startTime,
    segments,
    status,
    isWorkoutComplete: isWorkoutComplete.current
  };
  if (SNAPSHOT_KEY.indexOf("undefined") == -1)
  {
    console.log("savinf snapshot", snapshot);
    sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snapshot));
  }
  var onExerChange = props.onExerChange;
  //var onWorkoutComplete = props.onWorkoutComplete;

  if (props.onExerChange && status != "restarted")
  {
     onExerChange(exercises);
     //onWorkoutComplete(isWorkoutComplete);
  }
}

  return (
  <>
    {dialogNode}
    {showWorkoutCompleteModal && <div className="modal-backdrop" />}

     <div className={`AppEx ${showWorkoutCompleteModal ? 'disabled-screen' : ''}`}>
      
      <h2 style={{ color:'blue', fontSize: '22px', marginBottom:"10px", fontFamily:"monospace" }}>
        🧩 Namaste {showButtons?.title?.split("/")?.[0]?.trim()} 🧩
        <span style={{ fontWeight: 'bold', marginLeft: '15vw', color:'blue', fontSize: '14px' }}>
           ({showButtons?.username || ''})
        </span>
      </h2> 
  <div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "16px",
    width: "86%",
  }}
>
  {/* Column 1 */}
  <div>
    <div>
      <small>Total Time:</small>
    </div>
    <div style={{fontSize: 22}}>
      {formatTime(totalWorkoutTime)}
    </div>
    {(() => {
      const orig = originalTotalWorkoutTimeRef.current;
      if (orig === null || orig === totalWorkoutTime) return null;
      const diff = totalWorkoutTime - orig;
      const sign = diff > 0 ? '+' : '';
      const reason = diff > 0
        ? 'exercises added or durations increased during session'
        : 'exercises removed or durations reduced during session';
      return (
        <div style={{
          marginTop: 4, padding: '4px 6px', borderRadius: 4, fontSize: 11,
          background: diff > 0 ? '#fff3cd' : '#d4edda',
          color: diff > 0 ? '#856404' : '#155724',
          border: `1px solid ${diff > 0 ? '#ffc107' : '#28a745'}`,
        }}>
          {sign}{diff} min vs plan · {reason}
        </div>
      );
    })()}</div>

  {/* Column 2 */}
  <div style={{ textAlign: "center" }}>
   
    <div style={{ color: "green", }}>
      <small>Repetition:</small>{" "}
      </div>
      <div style={{ fontSize: 22 }}>
      {repetitionCount + 1} / {currentExercise.repetition}
    </div>
  </div>

  {/* Column 3 */}
  <div style={{ textAlign: "right" }}>
    <div>
      ⏱ Time Spent:
    </div>
    <div style={{fontSize: 22, color: "green"}}>
      {formatTime(elapsedTime)}
    </div>
  </div>
</div>

    
      { ( showButtons?.status == "scheduled") && viewMode === 'reorder'  ? (
        
        <div style={{ padding: '1rem' }}>
          <h3>🧩 Drag to reorder exercises before starting</h3>
          <DragDropContext 
          onDragStart={() => console.log("Dragging uper wala -- started - status", showButtons.status)}
            onBeforeDragStart={() => console.log("Before drag start")}
          onDragEnd={handleDragEnd}>
            <Droppable droppableId="exList">
              {provided => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {exercises.map((ex, idx) => {
                    console.log("Draggable id:", ex.id);
                    return (
                    <Draggable key={ex.id} draggableId={ex.id} index={idx}>
                      {provided => (
                        <div
                          className="exercise-item"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                           style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px',
                            width: 'auto',
                            height: 'auto',
                            borderBottom: '1px solid #ddd',
                            ...provided.draggableProps.style, // preserve drag styles
                          }}
                        >
                        <div style={{ flex: 1 }}>
                          {ex.name} | {parseInt(ex.duration,10) || 1} | {ex.repetition} reps | 
                        </div>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', fontWeight: 'bold' }}> 
                            {/* Duplicate icon/button */}
                        <button
                          style={{ cursor: 'pointer', width: '46px',border: 'none', fontSize: '22px', padding: '8px' }}
                          title="Duplicate exercise"
                          onClick={async () => {
                            const suffix = await showPrompt(
                              `Duplicate "${ex.name}"\nEnter suffix (e.g. Left, Right, Upper, Lower):`, ""
                            );
                            if (suffix !== null) {  // user did not cancel prompt
                              // Create duplicate
                              const newEx = {
                                ...ex,
                                id: ex.name + (suffix ? '-' + suffix : '') + '-' + (exercises.length + 1), // unique ID with suffix
                                name: ex.name + (suffix ? ' ' + suffix : ''), // add suffix to name displayed
                                status: "notStarted",
                                wasRestarted: false,
                                remarks: "",
                                comments: "",
                                lastExecuted: ""
                              };
                              const newExercises = [...exercises];
                              newExercises.splice(idx + 1, 0, newEx); // insert duplicate next to original
                              setExercises(newExercises);
                            }
                          }}
                        >
                         <FaPlusCircle />
                        </button>
                          {/* Remove button only if status is "notStarted" */}
                          {(!ex.status || ex.status === 'notStarted') && (
                            <button
                              style={{
                                cursor: 'pointer',
                                background: 'none',
                                border: 'none',
                                fontSize: '28px',
                                color: 'red',
                                padding: 0,
                                lineHeight: 1,
                              }}
                              title="Remove exercise"
                              onClick={async () => {
                                if (await showConfirm(`Remove exercise "${ex.name}" ?`)) {
                                  const newExercises = exercises.filter((e) => e.id !== ex.id);
                                  setExercises(newExercises);
                                }
                              }}
                            >
                              ❌
                            </button>
                          )}                          
                          <span style={{ color: 'black', fontWeight: 600, fontSize:'14px', textWrap: true }}>{ex.remarks}</span>
                          <span style={{ color: 'red', fontWeight: 600, fontSize:'14px', textWrap: true }}>{ex?.comments}</span>
                                                                      
                        </div>
                        </div>
                      )}
                    </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
       
        </div>
        ) : <></> }

      { (viewMode === 'reorder')  ? (
          <button style={{ marginTop: '1rem' }}
            onClick={async () => {
              var ret = !showButtons ? true: false;

                if (ret || (showButtons.status == "Skipped" || showButtons.status == "Completed"))
                {
                  ret = (ret == true) ? true : await showConfirm('Please take appointment first.');
                  if (ret) {
                    const params = new URLSearchParams({
                      mode: 'create',
                      patientCard:`${props.patientCard}`,
                      therapistName: `${props.therapistName}`,
                    }).toString();

                    window.open(
                      `${window.location.origin}/calendar-popup?${params}`,
                      'CreateAppointment',
                      'width=500,height=500'
                    );
                  }
            
                  return;
                }
                unlockAudio();
                setViewMode('timer');
                updateApptToInProgress();
              }}
            >
            {(showButtons ? 
              ((showButtons.status == "scheduled" ) ? '▶ Start Workout' : 
              (showButtons.status == "Skipped" || showButtons.status == "Completed") ? 'Workout Already Over. Start a new session ?' : "Resume Workout" ) 
              : 'Take Appointment' )}
            </button> 
      ) : 
      ( 
        
        <>
        { (showButtons?.status == "inprogress" || showButtons?.status == "scheduled") &&         
        <>
          {(isWorkoutComplete.current == false) &&
         <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '20px',   // ← spacing between name/repetition and DualRings
            }}>        
  
            <div className="exercise-info" 
                style={{ color: 'blue', fontSize: 24, fontWeight: 700,  textAlign: 'center' }}>
              <div><strong> {currentExercise.name} </strong></div>
           
            </div>

            <div 
              style={{ position: 'relative', width: 320, height: 320, margin: 'auto',   cursor: 'pointer' }}
              onClick={() => {
                // Same logic you use in your pause/play button
                unlockAudio();
                // Stop any buzzer or playing audio
                stopAudio();

                // Toggle pause only if workout not completed
                if (!isWorkoutComplete.current) {
                  setIsStopped(false);      // ensure not stuck in stop state
                  setIsPaused(prev => !prev);
                }
              }}
            >
              <DualRings
                outerRadius={160}
                outerStroke={16}
                innerRadius={140}
                innerStroke={11}
                innerProgress={progress}
                innerColor={COLORS[currentExerciseIndex % COLORS.length]}
                time={`${formattedTime}`}
                //time={`${currentExercise.name}\n${formattedTime}`}
                outerSegments={segments}
              />
            </div>
            </div>
            }
            <div className="controls">
              {isWorkoutComplete.current == false && (
                <button onClick={()=>{
                    unlockAudio();
                    stopAudio(); // stop before toggling pause/play
                    setIsStopped(false); // ✅ In case restored snapshot had it true
                    isWorkoutComplete.current = false; // ✅ Reset if snapshot had completed
                    setIsPaused(!isPaused);
                  }} 
                  className="icon-btn">
                  {isPaused ? <FaPlay /> : <FaPause />}
                </button>
              )}
              {!isPaused && !isStopped && (
                <button  onClick={() => {
                    unlockAudio();
                    stopAudio(); // stop before skipping
                    handleSkip();
                  }} className="icon-btn"><FaForward /></button>
              )}
            
              {showRestartSkipped && exercises.some(ex => ex.status === 'Skipped') && (
                <button  onClick={() => {
                    unlockAudio();
                    stopAudio(); // stop before restarting Skipped
                    restartSkipped();
                    
                  }} className="icon-btn">
                            🔁
                          </button>
                )}

                <button onClick={async ()=>{
                    await skipAllRemaining(1);
                  }}
                  className="icon-btn">
                   <FaBan />
                </button>
            </div>
          </>  
        }
        </>
        
      )}
      {showButtons && showExers && (viewMode != 'reorder') && 
      (showButtons?.status == "inprogress" || showButtons?.status == "scheduled") &&
      (
     <div className="exercise-container">
        <div className="exercise-list-left">
          <h3>Upcoming {upcomingExercises.length} <tb/>  </h3>
          <div className="exercise-grid">
           <DragDropContext 
             onDragStart={() => console.log("Dragging niche wala -- started - status", showButtons.status)}
           onDragEnd={handleUpcomingReorder}>
            <Droppable droppableId="upcomingList">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {upcomingExercises.map((ex, idx) => (
                    <Draggable key={ex.id} draggableId={ex.id} index={idx}>
                      {(provided) => (
                       <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={`exercise-item ${ex.wasRestarted ? 'restarted-highlight' : ''}`}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 16px',
                            borderBottom: '1px solid #ddd',
                            position: 'relative',
                              ...provided.draggableProps.style,  // <== add this line!
                          }}
                        >
                          {/* Left side: Name + remarks/comments below */}
                          <div style={{ flex: '1 1 95%', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              <span style={{ fontWeight: 600, fontSize: '16px' }}>{ex.name}</span>
                              {/* Restart icon top-right */}
                              {ex.wasRestarted && (
                                <span
                                  style={{
                                    color: 'orange',
                                    fontSize: '20px',
                                    userSelect: 'none',
                                    marginLeft: '8px',
                                  }}
                                  title="Restarted"
                                >
                                  🔁
                                </span>
                              )}
                            </div>

                            {/* Remarks, comments, duration, reps below name */}
                            <div style={{ fontSize: '14px', color: '#333', marginTop: '6px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                              <span>{formatTime(ex.duration ?? 1)}</span>
                              <span>{ex.repetition ?? 1} reps</span>
                              <span style={{ fontWeight: 600, color: 'black' }}>{ex.remarks}</span>
                              <span style={{ fontWeight: 600, color: 'red' }}>{ex?.comments}</span>
                            </div>
                          </div>

                          {/* Plus button on extreme right center */}
                          <button
                            style={{
                              cursor: 'pointer',
                              background: 'none',
                              border: 'none',
                              fontSize: '28px',
                              color: 'green',
                              padding: 0,
                              marginLeft: '12px',
                              alignSelf: 'center',
                              lineHeight: 1,
                            }}
                            title="Duplicate exercise"
                            onClick={async () => {
                              const suffix = await showPrompt(
                                `Duplicate "${ex.name}"\nEnter suffix (e.g. Left, Right, Upper, Lower):`, ""
                              );
                              if (suffix !== null) {  // user did not cancel prompt
                                const newEx = {
                                  ...ex,
                                  id: ex.name + (suffix ? '-' + suffix : '') + '-' + (exercises.length + 1), // unique ID with suffix
                                  name: ex.name + (suffix ? ' ' + suffix : ''), // add suffix to name displayed
                                  status: 'notStarted',
                                  wasRestarted: false,
                                  remarks: "",
                                  comments: "",
                                  lastExecuted: ""
                                };
                                const newExercises = [...exercises];
                                newExercises.splice(idx + 1, 0, newEx);
                                setExercises(newExercises);
                              }
                            }}
                          >
                            <FaPlusCircle />
                          </button>

                            {/* Remove button only if status is "notStarted" */}
                            {(!ex.status || ex.status === 'notStarted') && (
                              <button
                                style={{
                                  cursor: 'pointer',
                                  background: 'none',
                                  border: 'none',
                                  fontSize: '28px',
                                  color: 'red',
                                  padding: 0,
                                  lineHeight: 1,
                                }}
                                title="Remove exercise"
                                onClick={async () => {
                                  if (await showConfirm(`Remove exercise "${ex.name}"?`)) {
                                    const newExercises = exercises.filter((e) => e.id !== ex.id);
                                    setExercises(newExercises);
                                  }
                                }}
                              >
                                 ❌
                              </button>
                            )}
                        </div>

                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          </div>
        </div>

        <div className="exercise-list-right">
          <h3>Completed {completedExercises.length}</h3>
          <div className="exercise-grid">
            {completedExercises.map((ex, idx) => {
              const timeSpentSec = ex.duration * (ex.repetition - ex.pendingreps);
              return (
                <div
                  key={`completed-${idx}`}
                  className={`exercise-item ${ex.wasRestarted ? 'restarted-highlight' : ''}`}
                >
                  <span>
                    {ex.name} {ex.wasRestarted && <span style={{ color: 'orange' }}>🔁</span>}
                  </span> <br/>
                  <span>{formatTime(ex.duration)}</span>
                  <span>{ex.repetition} reps</span>
                  
                </div>
              );
            })}
          </div>
        </div>
      </div>
      )}
      <audio ref={audioRef} src="/session-over-new.mp3" preload="auto" playsInline />
     </div>
        {showWorkoutCompleteModal && (
        <div 
        style={{
          position: 'fixed',
          top: '30%',
          left: '50%',
          transform: 'translate(-50%, -30%)',
          backgroundColor: 'white',
          border: '2px solid #888',
          borderRadius: '10px',
          padding: '30px',
          zIndex: 1000,
          boxShadow: '0 0 15px rgba(0,0,0,0.5)'
        }}
        >
          <h2 style={{ color: 'green' }}>🏁 Session Complete!</h2>
          <p>Please "Mark Session Over"</p>
          <button
            onClick={() => {
              if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
                audioRef.current.loop = false;
              }
              if (soundLoopRef.current) {
                clearTimeout(soundLoopRef.current); // ✅ stop further looping
                soundLoopRef.current = null;
              }
              setShowWorkoutCompleteModal(false);
              setShowExers(false);
            }}
            style={{
              marginTop: '10px',
              padding: '10px 20px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            OK
          </button>
          
        </div>
      )}

    </>
    
  );
}

export default ExerciseTimerWithList;

